import axios, { AxiosError, AxiosResponse } from 'axios';
import { environment } from '../../../../environments/environment';
import { UserInvite } from '@med_poc/types';
import { cloneDeepWith } from 'lodash-es';

const trimExcludedKeyPattern = /(pass(word)?|token|secret|api[-_]?key|authorization|auth)/i;

const shouldSkipStringTrim = (key: unknown): boolean =>
  typeof key === 'string' && trimExcludedKeyPattern.test(key);

const deepTrimStrings = <T>(value: T): T =>
  cloneDeepWith(value, (currentValue, key) => {
    if (typeof currentValue !== 'string') return undefined;
    if (shouldSkipStringTrim(key)) return currentValue;
    return currentValue.trim();
  }) as T;

export const acceptInviteUserWithCode = async (inviteCode: string, password: string, birthDate: string) => {

  let postData: UserInvite['acceptUserInviteWithCode']['PostData'] = {
    code: inviteCode,
    password: password,
    birthDate: birthDate
  };

  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${environment.apiUrl}api/user-invites/acceptInviteUserWithCode`,
    headers: { 
      'Content-Type': 'application/json', 
    },
    data: JSON.stringify(postData),
  };

return axios.request(config)
.then((response) => {
  console.devlog(JSON.stringify(response.data));
  return response;
})
.catch((error) => {
  console.devlog(error);
  throw error;
});

}

export const inviteUserWithCode = async (invitee_email: string, firstName: string, lastName: string, birthDate: string, targetRole?: UserInvite['inviteUserWithCode']['PostData']['targetRole'], principalId?: string) => {

  let postData: UserInvite['inviteUserWithCode']['PostData'] = deepTrimStrings({
    "invitee_email": invitee_email,
    "firstName": firstName,
    "lastName": lastName,
    "birthDate": birthDate,
    "targetRole": targetRole,
    "principalId": principalId
  });

  let data = JSON.stringify(postData);

  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${environment.apiUrl}api/user-invites/inviteUserWithCode`,
    headers: { 
      'Content-Type': 'application/json', 
    },
    data : data
  };

  return axios.request(config)
  .then((response) => {
    console.devlog(JSON.stringify(response.data));
    return response;
  })
  .catch((error) => {
    console.devlog(error);
    throw error;
  });


}

/**
 * Registers a patient directly (no invite email), linking them to principalId (the doctor).
 */
export const registerUser = async (data) => {

  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${environment.apiUrl}api/users`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(data),
  };

  return axios.request(config)
  .then((response) => {
    console.devlog(JSON.stringify(response.data));
    return response;
  })
  .catch((error) => {
    console.devlog('create user failed:', error);
    throw error;
  });

}

/**
 * Fetch the pending user-invites
 */
export const getMyUserInvites = async (): Promise<AxiosResponse<UserInvite['getMyUserInvites']['ResponseData']['Success']>> => {
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `${environment.apiUrl}api/user-invites/getMyUserInvites`,
    headers: {},
  };

  return axios.request(config)
    .then((response) => response)
    .catch((err: Error | AxiosError) => {
      console.devlog("Error fetching user invites:", err);
      throw err;
    });
}

/**
 * Accept or decline a user-invite as the logged-in invitee.
 */
export const respondToUserInvite = async (code: string, reject?: boolean) => {
  let postData: UserInvite['respondToUserInvite']['PostData'] = { code, reject };

  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${environment.apiUrl}api/user-invites/respondToUserInvite`,
    headers: { 'Content-Type': 'application/json' },
    data: JSON.stringify(postData),
  };

  return axios.request(config)
    .then((response) => response)
    .catch((err: Error | AxiosError) => {
      console.devlog("Error responding to user invite:", err);
      throw err;
    });
}
